/** Read-only lookups generated by Unity. Never written by this app. */

export interface CatalogItem {
  id: string
  label: string
  type: string
  description: string
  saleBase: number
  /** Craftables only — resources are gathered, so they carry no unlock level. */
  unlockLevel?: number
  unlockCost?: number
  craftableType?: string
  difficulty?: number
  seasonal: boolean
  tags: string[]
  recipe?: { item: string; amount: number }[]
}

export interface CatalogTool {
  id: string
  title: string
  description: string
  type: string
  price: number
  speedModifier: number
}

export interface CatalogLocation {
  id: string
  title: string
  description: string
  type: string
  difficulty: number
  /** Quest ids that open this location. */
  prereqs: string[]
}

export interface CatalogEstate {
  id: string
  estateName: string
  description: string
  tier: number
  renownCap: number
  buildCost: number
}

export interface CatalogBoost {
  id: string
  boostId: string
  type: string
  label: string
  modifier: number
  cost: number
}

export interface CatalogSkin {
  id: string
  label: string
  description: string
  rarity: string
  skinType: string
}

export interface RawCatalogs {
  items: { craftables: CatalogItem[]; resources: CatalogItem[] }
  tools: CatalogTool[]
  locations: CatalogLocation[]
  estates: CatalogEstate[]
  boosts: CatalogBoost[]
  skins: CatalogSkin[]
}

/** Indexed for O(1) reference resolution during validation and pricing. */
export interface CatalogIndex {
  items: Map<string, CatalogItem>
  craftables: Map<string, CatalogItem>
  resources: Map<string, CatalogItem>
  tools: Map<string, CatalogTool>
  locations: Map<string, CatalogLocation>
  estates: Map<string, CatalogEstate>
  boosts: Map<string, CatalogBoost>
  skins: Map<string, CatalogSkin>
  raw: RawCatalogs
}

export const CATALOG_PATHS = [
  'catalog/items.json',
  'catalog/tools.json',
  'catalog/locations.json',
  'catalog/estates.json',
  'catalog/boosts.json',
  'catalog/skins.json',
] as const
